<template>
  <section class="p-6 flex flex-col gap-6">
    <nav class="text-gray-600 text-sm">
      <span class="font-semibold cursor-pointer" @click="router.push('/')">
        Home
      </span>
      <span class="mx-2">/</span>
      <span class="cursor-pointer font-semibold" @click="router.push({ name: 'Languages' })">
        Languages
      </span>
      <span class="mx-2">/</span>
      <span class="text-gray-800 font-bold">Add Language</span>
    </nav>

    <h3 class="font-bold text-2xl">Add Language</h3>

    <div
      v-if="errors.length"
      class="bg-red-50 border border-red-200 text-red-700 p-3 rounded-md text-sm"
    >
      <ul class="list-disc list-inside">
        <li v-for="(err, idx) in errors" :key="idx">{{ err }}</li>
      </ul>
    </div>

    <form @submit.prevent="submitForm" class="bg-white shadow rounded-lg p-6 flex flex-col gap-6">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Name (Arabic)</label>
          <input
            v-model="form.name_ar"
            class="border w-full rounded-md px-3 py-2"
            placeholder="العربية"
          />
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Name (English)</label>
          <input
            v-model="form.name_en"
            class="border w-full rounded-md px-3 py-2"
            placeholder="Arabic"
          />
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Code</label>
          <input
            v-model="form.code"
            class="border w-full rounded-md px-3 py-2"
            placeholder="ar, en, fr..."
          />
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Sort Order</label>
          <input
            v-model.number="form.sort_order"
            type="number"
            min="0"
            class="border w-full rounded-md px-3 py-2"
          />
        </div>
      </div>

      <div>
        <label class="inline-flex items-center gap-2 text-sm">
          <input type="checkbox" v-model="form.is_active" />
          <span>Active</span>
        </label>
      </div>

      <div class="flex justify-end gap-3">
        <button
          type="button"
          class="px-4 py-2 border rounded-md"
          @click="router.push({ name: 'Languages' })"
          :disabled="isSubmitting"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-60"
          :disabled="isSubmitting"
        >
          <span v-if="isSubmitting">Saving...</span>
          <span v-else>Save</span>
        </button>
      </div>
    </form>
  </section>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import apiClient from "@/apiClient";

const router = useRouter();

const form = ref({
  name_ar: "",
  name_en: "",
  code: "",
  sort_order: 0,
  is_active: true,
});

const errors = ref([]);
const isSubmitting = ref(false);

function validate() {
  errors.value = [];
  if (!form.value.name_ar.trim()) errors.value.push("Arabic name is required.");
  if (!form.value.name_en.trim()) errors.value.push("English name is required.");
  if (!form.value.code.trim()) errors.value.push("Code is required.");
  return errors.value.length === 0;
}

async function submitForm() {
  try {
    if (!validate()) return;
    isSubmitting.value = true;

    const res = await apiClient.post("/languages", form.value);
    console.log("Language created:", res.data);

    router.push({ name: "Languages" });
  } catch (error) {
    console.error("Error creating language:", error);
    if (error.response?.data) {
      const data = error.response.data;
      if (data.message) errors.value.push(data.message);
      if (data.errors) {
        Object.values(data.errors).forEach((msgs) =>
          msgs.forEach((m) => errors.value.push(m))
        );
      }
    } else {
      errors.value.push("Failed to create language.");
    }
  } finally {
    isSubmitting.value = false;
  }
}
</script>
